import BaseDB from 'libs/DB/BaseDB'
import type { SendStatusResponse } from 'services/read-receipt'

/**
 * BaseDB.addData(key, data)는 내부에서 { [key]: keyValue, [dataKey]: data, expireTime, isExpired } 형태로
 * wrap한 뒤 저장하고, getData() 도 wrap된 객체를 반환한다. TS 타입에는 wrap이 자동 노출되지 않으므로
 * generic T를 wrap 구조로 직접 정의한다 (jmapDownloadCache 패턴).
 */
export interface ReadReceiptStatusCacheRecord {
  receipt_id: string
  data: SendStatusResponse
  expireTime?: number | null
  isExpired?: () => boolean
}

/**
 * 수신확인 메일 status 캐시 — 발송자 본인이 본 자기 수신확인 메일의 status를 저장.
 * 저장 조건: API 응답에서 `read === total && total > 0` (모두 수신) — 그 시점부터는 변할 일 없음.
 * 부분 수신 상태는 저장하지 않고 매번 재요청.
 *
 * 사용:
 *   addData(receiptId, statusData)   // BaseDB가 { receipt_id, data, expireTime } 으로 wrap
 *   getData(receiptId).data          // payload 접근 (default dataKey = 'data')
 */
const readReceiptStatusCacheDB = new BaseDB<ReadReceiptStatusCacheRecord>(
  'readReceiptStatusCacheDB',
  {
    version: 1,
    key: 'receipt_id',
    expireDuration: 30 * 24 * 60 * 60 * 1000, // 30일
    skipPreload: true,
  },
)

export default readReceiptStatusCacheDB
